<template>
<div>
  <sui-segment v-if="mode == 'view'">
	  <sui-header>
		  <v-row>
			  <v-col cols=12 md=5>
		  <h2>{{$t("category")}}: {{current.name}}</h2>
			</v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6 style="text-align:right">
				<div>
					<v-btn color="orange" @click.prevent="handleEdit"><v-icon>mdi-pen</v-icon></v-btn>&nbsp;
					<v-btn color="red"  @click.prevent="handleDelete"><v-icon>mdi-trash-can</v-icon></v-btn>
				</div>
			</v-col>
		</v-row>
	  </sui-header>
	  <sui-divider></sui-divider>
		  <v-row>
			  <v-col cols=12 md=5>

				<v-simple-table>
				<template v-slot:default>
				<tbody>
					<!-- <tr><td>{{$t("name")}}: {{ current.firstname }} {{current.lastname}}</td></tr> -->
					<tr><td>{{$t("name")}}: {{ current.name }}</td></tr>
					<tr><td>{{$t("color")}}: <v-chip :color="current.color != null ? current.color : '#e0e0e0'">{{current.color != null ? current.color : "#e0e0e0"}}</v-chip></td></tr>
				</tbody>
				</template>
			</v-simple-table>


			  </v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6>
				<h3>{{$t('products')}}</h3>
                <v-simple-table dense>
				<template v-slot:default>
				<thead>
					<tr>	
					<th class="text-left">
						{{$t("image")}}
					</th>
					<th class="text-left">
						{{$t("name")}}
					</th>
					<th class="text-left">
						{{$t("productID")}}
					</th>
					</tr>
				</thead>
				<tbody v-if="current.products.length > 0">
					<tr
					@click.prevent="$router.push('/product/'+prod.id)"
					v-for="prod in current.products"
					:key="prod.id">
					<td><img :src=" prod.image"></td>
					<td>{{ prod.name }}</td>
					<td>{{ prod.id }}</td>
					</tr>
				</tbody>
				<!-- <div v-else style="text-align:center;">{{$t("noData")}}</div> -->
				</template>
				</v-simple-table>
				<br>				<sui-divider></sui-divider>
				<h3>{{$t('groups')}}</h3>
                <v-chip
                  style="margin-right: 12px"
                  v-for="group in current.groups"
                  :key="group.id"
				  :color="group.color"
                  >{{ group.name }}</v-chip
                >
				<br>
				</v-col>
		  </v-row>
	    <v-overlay :value="loading"
		absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>


  </sui-segment>


	<!-- Edit -->

  <sui-segment v-else>
	  <sui-header>
		  <v-row>
			<v-col cols=12 md=1>
					<v-btn color="green"  @click.prevent="handleView"><v-icon>mdi-eye</v-icon></v-btn></v-col>
			  <v-col cols=12 md=5>
		  <!-- <h2>{{$t(current.name)}}</h2> -->
		  <!-- <v-text-field large :label="$t('name')" v-model="edit.name"></v-text-field> -->
		  <h2>{{$t("edit")}}: {{current.name}}</h2>
			</v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=5 style="text-align:right">
					<v-btn color="red"  @click.prevent="handleDelete"><v-icon>mdi-trash-can</v-icon></v-btn>
			</v-col>
		</v-row>
	  </sui-header>
	  <sui-divider></sui-divider>
		  <v-row>
			  <v-col cols=12 md=5>
		  		<v-row>
					<v-text-field :rules="rules.required" v-model="edit.name" :label="$t('name')"></v-text-field>&nbsp;
					<sui-divider></sui-divider></v-row>
				<br>
				 <v-color-picker
			 v-model="edit.color"
			 elevation="15"
			></v-color-picker>
			  </v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6>
				  

				<v-row>
			  <v-col cols=12 md=11>
						<h3>{{$t('products')}}</h3>
			  </v-col>
			  <v-col cols=12 md=1>
						<v-btn color="green" @click.prevent="handleAddProd()"><v-icon>mdi-plus</v-icon></v-btn>
			  </v-col>
				</v-row>	
                <v-simple-table dense>
				<template v-slot:default>
				<thead>
					<tr>	
					<th class="text-left">
						{{$t("image")}}
					</th>	
					<th class="text-left">
						{{$t("name")}}
					</th>
					<th class="text-left">
						{{$t("email")}}
					</th>
					<th class="text-right">
						{{$t("actions")}}
					</th>
					</tr>
				</thead>
				<tbody v-if="current.products.length > 0">
					<tr
					@click.prevent=" !noClick?$router.push('/product/'+prod.id):''"
					v-for="prod in current.products"
					:key="prod.id">
					<td><img :src="prod.image"></td>
					<td>{{ prod.name }}</td>
					<td>{{ prod.id }}</td>
					<td class="text-right"><v-btn icon color="red" @click.prevent="removeProduct(prod)"><v-icon>mdi-trash-can</v-icon></v-btn></td>
					</tr>
				</tbody>
				<!-- <div v-else style="text-align:center;">{{$t("noData")}}</div> -->
				</template>
				</v-simple-table>
				<br>
		<sui-divider></sui-divider><br>
				<h3>{{$t('groups')}}</h3>
			<v-combobox
         	v-model="edit.groups"
          	:items="groups"
          	multiple
			  :placeholder="$t('groups')"
		  	item-key="id"
			item-text="name"
          	chips>
          <template v-slot:selection="data">
            <v-chip
			:color="data.item.color"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-combobox>
				<br>
		<sui-divider></sui-divider><br>
					<v-btn color="green" :loading="buyLoading" block @click.prevent="saveEdit" x-large>{{$t('save')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
				</v-col>
		  </v-row>
		 <v-dialog v-model="showDialog" width="900">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t("addProducts") }}
              </v-card-title>
              <v-card-text>
						<v-combobox
						v-model="edit.dropdownData"
						:items="dropdownData"
						:label="$t('add')"
						multiple
						item-key="key"
						item-text="value"
						chips>
					</v-combobox>
					<v-btn color="green" :loading="userLoading" block @click.prevent="saveProducts">{{$t('save')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
			  </v-card-text>
			</v-card>
		</v-dialog> 
	    <v-overlay :value="loading"
		absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </sui-segment>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService.js";
// import PermissionService from "@/services/PermissionService.js";
export default {
	data() {
		return {
			current: {},
			loading: false,
			mode: "view",
			id: 0,
			isAdmin: false,
			edit: {},
			dropdownData: [],
			noClick: false,
			ddown: "",
			userLoading: false,
			showDialog: false,
			rules: {
				required: [v => v.length > 0 || this.$t("required")]
			},
			groups: []
		}
	},
	async created(){
		this.id = this.$route.params.id
		this.isAdmin = this.$store.getters.role.name == "shopadmin"
		this.loading = true;
		if(this.$route.query.edit && this.isAdmin){
			this.mode = "edit";
        window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
		}
		this.renderContent();
		let res = await ApiService.getProductDropdown({category:this.id})
		if(res.status == 200){
			for(let [key, value] of Object.entries(res.data)){
				this.dropdownData.push({key:key, value:value})
			}
		}
		res = await ApiService.getGroups()
		this.groups = res.data
	},
	methods: {
		async renderContent(){
			this.loading = true
			let res = await ApiService.getCategory(this.id)
			if(res.status == 200){


				this.current = res.data
				if(this.mode == "edit"){
					this.edit = this.current
				}
				this.loading = false
			}else if(res.status == 401){
				this.$router.push("/management/categories");
				this.$swal({
							icon: "error",
							title: this.$t("error"),
							text: this.$t("noPerm")
						})
			}
		},
		handleAddProd(){
			this.showDialog = true
		},
		async removeProduct(prod){
			this.noClick = true
			let res = await ApiService.removeProduct(this.id, {product:prod.id});
		if(res.status == 200){
				this.$swal({
							icon: "success",
							title: this.$t("deleted"),
							text: this.$t("deleteSuccess")
						})
			this.renderContent()
		}else{
				this.$swal({
							icon: "error",
							title: this.$t("error"),
							text: this.$t(res.data.error)
						})
		}
			this.noClick = false;
		},
		async saveProducts(){
			let res = await ApiService.addProducts(this.id, {products:this.edit.dropdownData});
			if(res.status == 200){
				this.$swal({
							icon: "success",
							title: this.$t("yea"),
							text: this.$t("saved")
						})
				this.showDialog = false
			this.renderContent()
			}else{
				this.$swal({
							icon: "error",
							title: this.$t("error"),
							text: this.$t(res.data)
						})
			}
		},
        async handleDelete(){
            this.$swal.fire({
                icon: "warning",
                title: this.$t("areYouSure"),
                text: this.$t("youCantRevert"),
                showCancelButton: false,
                showDenyButton: true,
                confirmButtonText: this.$t('yesDelete'),
                denyButtonText: this.$t("noKeep")
                }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await ApiService.deleteCategory(this.current.id);
                    if (res===false) {
                        this.updateTable++
                        this.$swal({
                            icon: "success",
                            title: this.$t("deleted"),
                            text: this.$t("deleteSuccess")
                        })
                    }
                }
            })
        },
		handleEdit(){
			this.edit = JSON.parse(JSON.stringify(this.current))
			// this.edit = temp
			// temp = null
			this.mode = 'edit'
		},
		handleView(){
			this.mode = 'view'
		},
		async handleAcceptItem(item, accepted){
			let res = await ApiService.acceptItem(item.id, {accepted: accepted})
			if(res.status == 201){
				this.renderContent()
			}
		},
		async saveEdit(){
			this.loading = true;
			this.buyLoading = true;
			let res = await ApiService.putCategory(this.edit.id,{
				"name": this.edit.name,
				"color": this.edit.color,
				"groups": this.edit.groups
			})
			if(res.status == 200){
				this.loading = false;
			this.buyLoading = false;


				this.current = res.data
				this.edit = this.current
				this.$swal({
					icon: "success",
					title: this.$t("yea"),
					text: this.$t("saved")
				})
			}else{
				this.loading = false;
			this.buyLoading = false;
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					text: this.$t(res.data.message)
				})
			}
		}
	}
}
</script>

<style>
.extra {
	margin-right:2%;
}
img {
	max-width: 150px !important;
	max-height: 150px !important;
}
</style>